<template>
  <el-row :gutter="10">
    <el-col :span="17">
      <div id="map" style="background-color: #ddd; min-height: 680px">地图</div>
    </el-col>
    <el-col :span="2">
      <div></div>
      <div class="op">
        <el-button
          type="danger"
          size="mini"
          :disabled="elements.length === 0"
          @click="remove"
        >
          清除正在编辑
        </el-button>
      </div>
      <div class="op">
        <el-button size="mini" @click="dialogVisible = true">
          导入参考对象
        </el-button>
      </div>
      <div class="op">
        <el-button type="primary" size="mini" @click="createPolygon">
          创建面
        </el-button>
      </div>
      <div class="op">
        <el-button type="primary" size="mini" @click="createPolyline">
          创建线
        </el-button>
      </div>
      <div>
        <ul>
          <li
            style="cursor: pointer; padding: 5px"
            ref="chart"
            v-for="(v, k) in elements"
            :key="k"
            @click="choose(k)"
          >
            {{ v | name }}
          </li>
        </ul>
      </div>
    </el-col>
    <el-col :span="5">
      <el-button type="primary" size="mini" @click="parseJson">
        生成json
      </el-button>
      <el-input
        type="textarea"
        :rows="30"
        v-model="json"
        placeholder="地图上活动对象转换为geojson的内容显示在这里"
      />
    </el-col>
    <el-dialog title="导入" :visible.sync="dialogVisible" width="50%">
      <el-input
        type="textarea"
        :rows="15"
        :placeholder="`形如[[经度值,纬度值],[经度值,纬度值],[经度值,纬度值]...]`"
        v-model="importString"
      ></el-input>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="importJson"> 确 定 </el-button>
      </span>
    </el-dialog>
  </el-row>
</template>
<script>
import Map from './Geo.js'
export default {
  name: 'Geo',
  data() {
    return {
      /**
       * 地图对象
       */
      map: undefined,
      /**
       * 已经绘制在地图上的对象（线、面等）
       */
      elements: {},
      /**
       * 导入的对话框是否可见
       */
      dialogVisible: false,
      /**
       * 导出的json
       */
      json: '',
      /**
       * 导入的json
       */
      importString: '',
    }
  },
  mounted() {
    this.map = new Map(this, 'map')
  },
  filters: {
    name: function (element) {
      if (element.type === 'PolylineOut') {
        return `线${element.key}`
      } else {
        return `面${element.key}`
      }
    },
  },
  beforeDestroy() {
    // TODO 最好销毁地图，回收资源
  },
  methods: {
    /**
     * 创建面
     */
    createPolygon() {
      const element = this.map.createPolygon()
      this.$set(this.elements, element.key, element)
    },
    /**
     * 创建线
     */
    createPolyline() {
      const element = this.map.createLine()
      this.$set(this.elements, element.key, element)
    },
    /**
     * 把当前活动要素转换为坐标数组
     */
    parseJson() {
      const json = this.map.jsonString()
      this.json = json ? JSON.stringify(this.map.jsonString()) : '无效数据'
    },
    /**
     * 选中一个要素
     */
    choose(key) {
      this.map.activate(key)
    },
    /**
     * 删除活动要素
     */
    remove() {
      const key = this.map.outlineRemove()
      this.$delete(this.elements, key)
    },
    /**
     * 导入坐标数组
     */
    importJson() {
      const imported = this.map.createByCoordinates(this.importString)
      if (imported) {
        this.elements[imported.key] = imported
      } else {
        // TODO 提示数据格式错误
      }
      this.dialogVisible = false
    },
  },
}
</script>
<style scoped>
.op {
  margin-top: 10px;
}
ul {
  padding: 0;
}
ul li {
  padding: 0;
  list-style: none;
}
.bgColor {
  background-color: red;
}
</style>
<!--地图标点图标-->
<style>
#map .point {
  display: inline-block;
  width: 15px;
  height: 15px;
  background-image: url('./point.png');
  background-size: 15px 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/_util/Geo.vue